import { useMemo } from "react";
import { useParams, Navigate } from "react-router-dom";
import { useInfluencer } from "../hooks/useInfluencer";
import InfluencerDetails from "./InfluencerDetails";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import { applyInfluencerRatingFallback } from "../utils/rating";

const InfluencerDetailsPage = () => {
  const { username } = useParams();
  const { influencer, loading, error } = useInfluencer(username);
  const displayInfluencer = useMemo(
    () => applyInfluencerRatingFallback(influencer),
    [influencer]
  );

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-800" />
      </div>
    );
  }

  if (error || !displayInfluencer) return <Navigate to="/marketplace" replace />;

  return (
    <>
      <Navbar />
      <InfluencerDetails influencer={displayInfluencer} />
      <Footer />
    </>
  );
};

export default InfluencerDetailsPage;
